/**
 * Firebase configuration for the ring-swipe project
 *
 * Note: These are public Firebase config values that are safe to include in client-side code.
 * They are used to identify your Firebase project, not to grant access.
 * Security is enforced by Firestore Security Rules.
 */
export const firebaseConfig = {
  apiKey: "AIzaSyDQF2KkOVQUg1HpsxMraXGjtWf2QBJ2Ls8",
  authDomain: "ring-swipe.firebaseapp.com",
  databaseURL: "https://ring-swipe-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ring-swipe",
  storageBucket: "ring-swipe.appspot.com",
  messagingSenderId: "265523785724",
  appId: "1:265523785724:web:88fda6ab79f8f72b6d8c79",
  measurementId: "G-57223QKFEC",
} as const;

export type FirebaseConfig = typeof firebaseConfig;
